export default "__VITE_ASSET__DTDsacNe__"